/* IG507 — Cotizador integral 2026-10-19 | Reemplaza TODO el JS anterior.
   Compatible con sections/carmat29-cotizador.liquid de 7 pasos.
   Voz local = Web Speech API; IA avanzada requiere API verificada.
*/
(() => {
  'use strict';
  const VERSION = 'CARMAT29-FOTOS-REPARADAS-20261024-R3';
  // Todas las zonas pulsables del PNG comparten estas dimensiones.
  const QUOTE_LAYOUT = Object.freeze({width:1080,height:1820,photoExtra:140});
  const CONFIG = {
    logo: 'https://cdn.shopify.com/s/files/1/0713/9796/5935/files/Round_Photo_May022026_175629.png?v=1792708521',
    video: 'https://cdn.shopify.com/videos/c/o/v/2e83bf5d572f4f2fa9e247135381af29.mp4',
    imageAPI: 'https://ig507-vehicle-images.vercel.app/api/vehicle-image', // API heredada: verificar acceso antes de publicar
    whatsapp: 'https://wa.me/message/RZZJS4PD7KORB1',
    wompi: 'https://checkout.wompi.pa/l/VPOS_DIZJxQ',
    website: 'www.carmat29.com',
    shipping: { premium: 0, air: 15, express: 21, sea: 9.4 },
    shippingLabels: { premium:'Internacional Premium', air:'Aéreo DDP', express:'Exprés', sea:'Marítimo' },
    shippingDays: { premium:'10–20 días', air:'5–10 días', express:'2–4 días', sea:'25–30 días' },
    estimateKg: 9
  };
  const CAR_MODELS = {
    Toyota:'Hilux,Corolla,Yaris,RAV4,Fortuner,Land Cruiser,Prado,4Runner,Tacoma,Tundra,Camry,Hiace,Avanza,Rush,Raize,Corolla Cross,C-HR,Prius',
    Hyundai:'Accent,Elantra,Tucson,Santa Fe,Creta,Kona,Venue,Sonata,Grand i10,i10,i20,Palisade,H-1,Staria',
    Kia:'Rio,Picanto,Sportage,Sorento,Seltos,Sonet,Carnival,Cerato,K3,K5,Telluride,Soul,Niro',
    Honda:'Civic,Accord,CR-V,HR-V,Pilot,Fit,City,Odyssey,Ridgeline,WR-V,BR-V',
    Nissan:'Sentra,Versa,Altima,Frontier,Navara,X-Trail,Kicks,Qashqai,Pathfinder,Patrol,March,Murano',
    Chevrolet:'Sail,Aveo,Onix,Tracker,Captiva,Equinox,Traverse,Tahoe,Suburban,Colorado,Silverado,Spark,Cruze,D-Max',
    Ford:'Ranger,Explorer,Escape,Edge,Bronco,Everest,F-150,Mustang,Focus,Fiesta,Expedition,Territory',
    Mazda:'Mazda 2,Mazda 3,Mazda 6,CX-3,CX-30,CX-5,CX-50,CX-60,CX-9,CX-90,BT-50',
    Mitsubishi:'L200,Triton,Montero,Montero Sport,Outlander,ASX,Eclipse Cross,Mirage,Xpander,Pajero',
    Suzuki:'Swift,Vitara,Grand Vitara,Jimny,Baleno,Celerio,S-Presso,Ertiga,XL7,Fronx,Dzire',
    Volkswagen:'Jetta,Bora,Voyage,Golf,Polo,Virtus,Tiguan,Taos,T-Cross,Amarok,Passat,Nivus,Saveiro',
    Isuzu:'D-Max,MU-X,Rodeo,Trooper,NPR,NQR',
    Jeep:'Wrangler,Grand Cherokee,Cherokee,Compass,Renegade,Gladiator,Commander,Patriot',
    BMW:'Serie 1,Serie 2,Serie 3,Serie 4,Serie 5,Serie 7,X1,X2,X3,X4,X5,X6,X7',
    Audi:'A1,A3,A4,A5,A6,A7,A8,Q2,Q3,Q5,Q7,Q8',
    'Mercedes-Benz':'Clase A,Clase B,Clase C,Clase E,Clase S,CLA,GLA,GLB,GLC,GLE,GLS,Sprinter,Vito',
    Subaru:'Impreza,Legacy,Outback,Forester,Crosstrek,XV,WRX,Ascent,BRZ',
    Peugeot:'208,2008,308,3008,408,5008,Partner,Rifter',
    Renault:'Kwid,Logan,Sandero,Duster,Koleos,Captur,Oroch,Arkana,Kardian',
    Changan:'CS15,CS35,CS35 Plus,CS55,CS55 Plus,CS75,CS75 Plus,UNI-T,UNI-K,UNI-V,Hunter',
    Chery:'Tiggo 2,Tiggo 4,Tiggo 7,Tiggo 8,Tiggo 9,Arrizo 5,Arrizo 8',
    Geely:'Coolray,Azkarra,Okavango,Emgrand,Starray,GX3 Pro',
    BYD:'Dolphin,Dolphin Mini,Seal,Song Plus,Yuan Plus,Atto 3,Tang,Han,Shark',
    JAC:'S2,S3,S4,S5,S7,T6,T8,JS2,JS3,JS4,JS6,J7',
    Fiat:'Uno,Mobi,Argo,Cronos,Pulse,Fastback,Strada,Toro,Fiorino,500',
    Lifan:'320,520,620,X50,X60,X70,820',
    Dodge:'Charger,Challenger,Durango,Journey,Caravan',
    RAM:'700,1000,1500,2500,3500,Rampage'
  };
  const normalize = s => String(s ?? '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  const escapeHTML = s => String(s ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const byAttr = (el, attr) => el && el.getAttribute(attr);
  const list = s => String(s).split(',').map(v=>v.trim());
  function init(root) {
    if (root.dataset.ig507Restored === VERSION) return;
    // Datos de marca editables sin volver a cambiar el JS.
    if (root.dataset.carmat29Logo) CONFIG.logo = root.dataset.carmat29Logo;
    if (root.dataset.carmat29Robot) CONFIG.video = root.dataset.carmat29Robot;
    root.dataset.ig507Restored = VERSION;
    const $ = (s, parent=root) => parent.querySelector(s);
    const $$ = (s, parent=root) => Array.from(parent.querySelectorAll(s));
    const F = { brand:'.mk', model:'.md', year:'.yr', body:'.vt', seats:'.st', trunk:'.tr', primary:'.primary', secondary:'.upper' };
    const state = {
      brand:'', model:'', year:'', body:'', seats:'', trunk:'', primary:'', secondary:'',
      use:'', needs:[], priority:'', material:'', shipping:'', lastPurchase:'',
      product:null, vehicleImage:'', vehicleImageLabel:'', uploadImage:'',
      confirmed:new Set(), seconds:0, begun:false, complete:false, startAt:0,
      photos:[], mainPhoto:0, stage:'welcome',
      dialog:[], quoteBlob:null, quoteURL:'', quoteText:'', pendingImage:false, cartAddedVariant:''
    };
    let timer = null, imageRequest=0, speaking=false, listening=false, voiceOn=false, recognition=null, processingVoice=false;
    const SpeechAPI = window.SpeechRecognition || window.webkitSpeechRecognition;
    const safeCurrency = (root.dataset.currency || window.Shopify?.currency?.active || 'USD').toUpperCase();
    const money = n => { if(safeCurrency==='USD')return '$'+Number(n).toFixed(2); try { return new Intl.NumberFormat(safeCurrency==='EUR'?'es-ES':'es-PA',{style:'currency',currency:safeCurrency,minimumFractionDigits:2,maximumFractionDigits:2}).format(n); } catch { return `${safeCurrency} ${Number(n).toFixed(2)}`; } };
    const counts = () => state.confirmed.size;
    const mark = name => { if (name && typeof name==='string') state.confirmed.add(name); };
    const scrollTo = el => el && el.scrollIntoView({behavior:'smooth',block:'start'});
    function elapsedSeconds(){ return state.begun ? Math.max(0, Math.floor(((state.complete ? state.finishedAt : Date.now()) - state.startAt)/1000)) : 0; }
    function displayClock(){
      state.seconds=elapsedSeconds();
      const remaining=60-state.seconds;
      const formatted = state.seconds < 60 ? `${String(Math.floor(remaining/60)).padStart(2,'0')}:${String(remaining%60).padStart(2,'0')}` : `+${Math.floor((state.seconds-60)/60)}:${String((state.seconds-60)%60).padStart(2,'0')}`;
      $$('[data-ig507-clock]').forEach(el=>{el.textContent=formatted;el.dataset.over=String(state.seconds>=60);});
      const badge=$('[data-ig507-elapsed]'); if(badge) badge.textContent=`⏱️ ${state.seconds}s`;
    }
    function startTimer(){
      if(state.begun || state.complete) return;
      state.begun=true; state.startAt=Date.now();displayClock();
      timer=setInterval(displayClock,500);
    }
    function finishTimer(){if(state.complete)return;state.finishedAt=Date.now();state.complete=true;clearInterval(timer);displayClock();}
    function setStatus(text){ const el=$('[data-ig507-voice-status]'); if(el) el.textContent=text; }
    function hint(text){ const el=$('[data-ig-smart-msg]'); if(el) el.textContent=text; }
    function log(text,who='assistant'){
      const box=$('[data-ig507-dialog]'); if(!box)return;
      const p=document.createElement('p');p.className=who;p.textContent=`${who==='user'?'👤':'🤖'} ${text}`;box.appendChild(p);
      while(box.childNodes.length>10)box.removeChild(box.firstChild);box.scrollTop=box.scrollHeight;
      state.dialog.push({who,text});if(state.dialog.length>20)state.dialog.shift();
    }
    function setSelect(selector, value, allowNew=false){
      const el=$(selector);if(!el || value===undefined || value===null)return false;
      const n=normalize(value); if(!n)return false;
      let option=Array.from(el.options).find(o=>normalize(o.value)===n || normalize(o.textContent)===n);
      if(!option)option=Array.from(el.options).find(o=>normalize(o.textContent).includes(n) && o.value);
      if(!option && allowNew){option=new Option(String(value),String(value));el.add(option);}
      if(!option)return false;
      if(el.value!==option.value){el.value=option.value;el.dispatchEvent(new Event('change',{bubbles:true}));}
      return true;
    }
    function vehicleRows(){
      const output=[];const seen=new Set();
      const push=(make,model,record={})=>{
        make=String(make||'').trim();model=String(model||'').trim();if(!make||!model)return;
        const key=normalize(make)+'|'+normalize(model)+'|'+String(record.year||'');
        if(!seen.has(key)){seen.add(key);output.push({make_name:make,model_name:model,...record});}
      };
      const visit=(obj,defaultBrand='')=>{
        if(!obj)return;
        if(Array.isArray(obj)){
          for(const o of obj){
            if(typeof o==='string'){if(defaultBrand)push(defaultBrand,o);continue;}
            if(!o||typeof o!=='object')continue;
            const make=o.make_name||o.make||o.brand||o.marca||o.fabricante||defaultBrand;
            const model=o.model_name||o.model||o.modelo||o.vehicle_model;
            if(model)push(make,model,o);
            else visit(o.models||o.modelos||o.vehicles||o.vehiculos,make);
          }return;
        }
        if(typeof obj==='object'){
          if(obj.rows||obj.data||obj.vehicles||obj.vehiculos||obj.brands||obj.marcas)
            return visit(obj.rows||obj.data||obj.vehicles||obj.vehiculos||obj.brands||obj.marcas,defaultBrand);
          Object.entries(obj).forEach(([brand,models])=>visit(models,brand));
        }
      };
      [window.IG507VehicleDB,window.IG507_VEHICLES,window.IG507_VEHICLES_DB,window.IG507_VEHICLE_DB,window.IG507_DATABASE,window.VEHICLE_DATABASE,window.vehiclesData].forEach(v=>visit(v));
      return output;
    }
    function supportedModels(brand){
      const extra=vehicleRows().filter(r=>normalize(r.make_name)===normalize(brand)).map(r=>r.model_name);
      const key=Object.keys(CAR_MODELS).find(k=>normalize(k)===normalize(brand));
      return [...new Set([...extra,...(key?list(CAR_MODELS[key]):[])])].sort((a,b)=>a.localeCompare(b,'es'));
    }
    function populateModels(brand, preferred='', keepCurrent=false){
      const el=$('.md');if(!el)return;
      const current=keepCurrent?el.value:'';
      const options=supportedModels(brand);
      el.replaceChildren(new Option('Selecciona modelo',''));
      options.forEach(m=>el.add(new Option(m,m)));
      const sought=preferred||current;
      if(sought){setSelect('.md',sought,true);}
      state.model=el.value||'';
      if(!state.model)state.confirmed.delete('model');
    }
    function setField(key, value, confirmed=true){
      if(value===null || value===undefined || String(value).trim()==='')return false;
      let chosen=String(value).trim();
      if(key==='model' && state.brand && $('.md') && !Array.from($('.md').options).some(o=>normalize(o.value)===normalize(chosen))) {
        populateModels(state.brand,chosen);
      }
      if(F[key]){
        const ok=setSelect(F[key],chosen,key==='brand'||key==='model');
        if(!ok)return false;
        chosen=$(F[key]).value;
      }
      state[key]=chosen;
      if(confirmed)mark(key);
      if(key==='brand'){ populateModels(chosen,state.model,true); }
      if(['use','priority','material','shipping'].includes(key)){
        const sel={use:'.ig-use [data-v]',priority:'.ig-priority [data-v]',material:'.ig-materials [data-material]',shipping:'.ig-ship-grid [data-ship]'}[key];
        const attr={use:'data-v',priority:'data-v',material:'data-material',shipping:'data-ship'}[key];
        const all=$$(sel);const chosenButton=all.find(b=>normalize(b.getAttribute(attr))===normalize(chosen));
        all.forEach(b=>b.classList.toggle('is-active',b===chosenButton));
      }
      if(['brand','model','year','body'].includes(key))scheduleVehicleImage();
      return true;
    }
    function choose(key, value, confirmed=true){
      if(key==='needs'){
        if(!state.needs.includes(value))state.needs.push(value);
        $$('.ig-needs [data-v]').forEach(b=>b.classList.toggle('is-active',state.needs.includes(b.dataset.v)));
        if(confirmed)mark('needs');return;
      }
      setField(key,value,confirmed);
    }
    function readManual(){
      Object.entries(F).forEach(([key,selector])=>{const el=$(selector);if(el){state[key]=el.value||'';if(!state[key])state.confirmed.delete(key);}});
      for(const [key,selector,attr] of [['use','.ig-use','v'],['priority','.ig-priority','v'],['material','.ig-materials','material'],['shipping','.ig-ship-grid','ship']]){
        const btn=$(selector+' .is-active');if(btn)state[key]=btn.dataset[attr]||'';
      }
      state.needs=$$('.ig-needs .is-active').map(b=>b.dataset.v);
    }
    function addOptionIfMissing(selector,text){const el=$(selector);if(el&&!Array.from(el.options).some(o=>o.value===text))el.add(new Option(text,text));}
    function knownBody(model){
      const m=normalize(model);
      if(/^(hilux|frontier|navara|ranger|l200|triton|d max|bt 50|amarok|tacoma|tundra|silverado|colorado|f 150|hunter|ram 1500|ram 2500|ram 3500)$/.test(m))return 'Pickup';
      if(/^(corolla|yaris|civic|accord|elantra|accent|sail|aveo|sentra|versa|jetta|bora|voyage|camry|mazda 3)$/.test(m))return 'Sedán';
      if(/^(rav4|fortuner|cr v|hr v|sportage|sorento|tucson|santa fe|x trail|kicks|cx 5|outlander|tiguan)$/.test(m))return 'SUV';
      return '';
    }
    function parseSpeech(input){
      const t=normalize(input);if(!t)return;
      const allBrandOptions=$$('.mk option').map(o=>o.value).filter(Boolean);
      const brands=[...new Set([...allBrandOptions,...Object.keys(CAR_MODELS)])].sort((a,b)=>b.length-a.length);
      const brand=brands.find(b=>new RegExp('(^| )'+normalize(b).replace(/[.*+?^${}()|[\]\\]/g,'\\$&')+'( |$)').test(t));
      if(brand)setField('brand',brand);
      const searchBrand=brand||state.brand;
      if(searchBrand){
        const candidates=supportedModels(searchBrand).sort((a,b)=>b.length-a.length);
        const model=candidates.find(m=>t.includes(normalize(m)));
        if(model)setField('model',model);
      }
      const year=t.match(/\b(19\d{2}|20\d{2})\b/);
      if(year && Number(year[1]) <= 2028)setField('year',year[1]);
      const seats=t.match(/\b(\d{1,2})\s*(?:asientos?|pasajeros?|plazas?)\b/);
      if(seats){const n=Number(seats[1]);if(n>=2&&n<=15)setField('seats',String(n));}
      let body='';
      if(/\b(pickup|pick up|camioneta doble cabina)\b/.test(t))body='Pickup';
      else if(/\b(sedan)\b/.test(t))body='Sedán';
      else if(/\b(suv|todoterreno)\b/.test(t))body='SUV';
      else if(/\b(hatchback)\b/.test(t))body='Hatchback';
      else if(/\b(minivan)\b/.test(t))body='Minivan';
      if(!body && state.model) body=knownBody(state.model);
      if(body)setField('body',body);
      if(/(?:sin|no (?:quiero|incluyas?|necesito))\s+(?:el\s+)?maletero|sin cajuela/.test(t))setField('trunk','sin');
      else if(/(?:con|incluye|agrega|quiero|necesito)\s+(?:el\s+)?maletero|con cajuela/.test(t))setField('trunk','con');
      const colorOptions=$$('.primary option').map(o=>o.value).filter(Boolean).sort((a,b)=>b.length-a.length);
      const found=[];
      for(const c of colorOptions){const n=normalize(c);const at=t.indexOf(n);if(at>=0 && !found.some(x=>x.start===at||normalize(x.value).includes(n)&&x.start===at))found.push({value:c,start:at,end:at+n.length});}
      found.sort((a,b)=>a.start-b.start||b.value.length-a.value.length);
      const colors=found.filter((item,i)=>!found.some((other,j)=>i!==j && other.start<=item.start && other.end>=item.end && other.value.length>item.value.length));
      if(colors.length){
        const secondaryOnly=/\b(color secundario|franja|bordes|costuras)\b/.test(t) && !/\b(color principal|combinacion| y | con )\b/.test(t);
        if(secondaryOnly)setField('secondary',colors[0].value);
        else {setField('primary',colors[0].value);if(colors[1])setField('secondary',colors[1].value);}
      }
      if(/mismo color|un solo color/.test(t) && state.primary)setField('secondary',state.primary);
      if(/\b(cuero|ecologico|acolchado)\b/.test(t))choose('material','Cuero Ecológico Artificial');
      else if(/\b(tpe|termoplastico|termoplastic)\b/.test(t))choose('material','TPE 5D');
      if(/\b(trabajo|laboral|empresa|reparto)\b/.test(t))choose('use','Trabajo');
      else if(/\b(familiar|familia)\b/.test(t))choose('use','Familiar');
      else if(/\b(aventura|campo)\b/.test(t))choose('use','Aventura');
      else if(/\b(diario|cotidiano)\b/.test(t))choose('use','Uso diario');
      [['Mascotas',/\b(mascotas?|perros?|gatos?)\b/],['Niños',/\b(ninos?|bebes?)\b/],['Agua',/\b(agua|lluvia)\b/],['Barro',/\b(barro|lodo)\b/],['Polvo',/\b(polvo)\b/],['Fácil limpieza',/\b(limpieza|facil de limpiar)\b/]].forEach(([key,re])=>{if(re.test(t))choose('needs',key);});
      if(/\b(proteccion|proteger|resistencia)\b/.test(t))choose('priority','Protección');
      else if(/\b(elegancia|elegante)\b/.test(t))choose('priority','Elegancia');
      else if(/\b(comodidad|comodo)\b/.test(t))choose('priority','Comodidad');
      else if(/\b(personalizacion|personalizado)\b/.test(t))choose('priority','Personalización');
      if(/\b(expres|express|urgente)\b/.test(t))choose('shipping','express');
      else if(/\b(maritimo|barco)\b/.test(t))choose('shipping','sea');
      else if(/\b(aereo|avion|ddp)\b/.test(t))choose('shipping','air');
      else if(/\b(premium|gratis|gratuito)\b/.test(t))choose('shipping','premium');
      if(/ultima vez|ultima compra|hace\s+\d+\s+(?:mes|ano)|nunca he comprado/.test(t)){state.lastPurchase=input;mark('lastPurchase');}
      readManual();
    }
    function nextQuestion(){
      for(const [field,text] of [
        ['brand','¿Cuál es la marca, el modelo y el año de tu automóvil?'],
        ['model','¿Cuál es el modelo exacto de tu automóvil?'],
        ['year','¿De qué año es tu automóvil?'],
        ['seats','¿Cuántos asientos tiene tu vehículo?'],
        ['material','¿Prefieres TPE 5D o cuero ecológico artificial?'],
        ['use','¿Usas tu vehículo para trabajo, familia o uso diario?'],
        ['primary','¿Qué color principal deseas?'],
        ['secondary','¿Y el segundo color? Puedes decir «el mismo».'],
        ['trunk','¿Quieres incluir la alfombra del maletero?'],
        ['shipping','¿Qué envío eliges: Premium gratuito, aéreo, exprés o marítimo?']]) {
        if(!state.confirmed.has(field) && (field==='needs'?state.needs.length===0:!state[field]))return text;
      }
      return 'Ya tengo tu configuración principal. Pulsa «Confirmar vehículo y elegir alfombras» para escoger el producto.';
    }
    function replyFor(t){parseSpeech(t);return 'Perfecto. '+nextQuestion();}
    async function processMessage(text,fromVoice=false){
      const input=String(text).trim();if(!input)return;
      startTimer();log(input,'user');
      let reply=replyFor(input);
      const url=root.dataset.aiEndpoint;
      if(url){
        try{
          const controller=new AbortController();const timeout=setTimeout(()=>controller.abort(),12000);
          const res=await fetch(url,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({message:input,fields:{...state,confirmed:[...state.confirmed],quoteBlob:undefined,quoteURL:undefined},history:state.dialog.slice(-8)}),signal:controller.signal});clearTimeout(timeout);
          if(res.ok){const data=await res.json();if(data.fields && typeof data.fields==='object')Object.entries(data.fields).forEach(([key,value])=>{if(F[key]&&typeof value==='string')setField(key,value);else if(['use','priority','material','shipping'].includes(key) && typeof value==='string')choose(key,value);});if(typeof data.reply==='string'&&data.reply.trim())reply=data.reply.trim();}
        }catch(e){setStatus('IA remota no disponible · asistente local');}
      }
      log(reply);
      if(fromVoice && voiceOn) speak(reply);
    }
    // Grabación por pulsación: una frase, envío y cierre del micrófono.
    // Nunca se reinicia automáticamente ni permanece escuchando de fondo.
    let voiceSession=0;
    function speak(t){
      if(!('speechSynthesis' in window))return;
      try{
        window.speechSynthesis.cancel();
        const utterance=new SpeechSynthesisUtterance(t);
        utterance.lang='es-PA';utterance.rate=1.03;
        speaking=true;
        utterance.onend=utterance.onerror=()=>{speaking=false;setStatus('🎙️ Toca para dictar');};
        window.speechSynthesis.speak(utterance);
      }catch(e){speaking=false;setStatus('🎙️ Toca para dictar');}
    }
    function stopVoice(){
      voiceOn=false;processingVoice=false;voiceSession++;
      const prev=recognition;recognition=null;
      if(prev){try{prev.onend=null;prev.onresult=null;prev.onerror=null;prev.abort();}catch(e){}}
      try{window.speechSynthesis?.cancel();}catch(e){}
      speaking=false;listening=false;
      setStatus('🎙️ Toca para dictar');
    }
    function startRecognition(){
      if(!voiceOn||listening||speaking)return;
      if(!SpeechAPI){voiceOn=false;setStatus('Dictado no compatible en este navegador');return;}
      const session=++voiceSession;
      let transcript='',sent=false;
      const handleTranscript=()=>{
        if(sent||session!==voiceSession)return;
        sent=true;voiceOn=false;listening=false;
        const phrase=transcript.trim();
        if(!phrase){setStatus('No se escuchó una frase. Pulsa para intentar otra vez.');return;}
        const smart=$('[data-ig-smart]');if(smart)smart.value=phrase;
        setStatus('✅ Dictado terminado · completando vehículo');
        processingVoice=true;
        Promise.resolve(processMessage(phrase,false))
          .then(()=>{if(session===voiceSession)setStatus('✅ Texto procesado · micrófono apagado');})
          .catch(()=>{if(session===voiceSession)setStatus('Texto recibido · revisa los campos');})
          .finally(()=>{processingVoice=false;});
      };
      try{
        const rec=new SpeechAPI();recognition=rec;
        rec.lang='es-PA';rec.interimResults=true;rec.continuous=false;
        rec.onstart=()=>{if(session!==voiceSession)return;listening=true;setStatus('🎙️ Escuchando tu vehículo…');};
        rec.onresult=event=>{
          if(session!==voiceSession)return;
          const results=Array.from(event.results);
          transcript=results.map(r=>r[0]?.transcript||'').join(' ').trim();
          const live=$('[data-ig507-live]');if(live)live.textContent='🎙️ '+transcript;
          const smart=$('[data-ig-smart]');if(smart)smart.value=transcript;
          if(results.some(r=>r.isFinal)){
            try{rec.stop();}catch(e){}
            handleTranscript();
          }
        };
        rec.onerror=event=>{
          if(session!==voiceSession)return;
          voiceOn=false;listening=false;
          if(event.error==='no-speech'){
            setStatus('No se escuchó nada. Pulsa para volver a dictar.');
          }else if(['not-allowed','service-not-allowed'].includes(event.error)){
            setStatus('Autoriza el micrófono de Chrome para dictar.');
          }else if(event.error!=='aborted'){
            setStatus('Micrófono: '+event.error+' · puedes escribir');
          }
        };
        rec.onend=()=>{
          if(session!==voiceSession)return;
          recognition=null;voiceOn=false;listening=false;
          // Chrome puede entregar solo texto provisional antes de cerrar.
          if(!sent && transcript.trim())handleTranscript();
          else if(!sent)setStatus('🎙️ Toca para dictar');
        };
        rec.start();
      }catch(e){voiceOn=false;listening=false;setStatus('No se pudo iniciar el dictado');}
    }
    function toggleVoice(){
      if(voiceOn||listening){stopVoice();return;}
      startTimer();voiceOn=true;
      setStatus('🎙️ Escuchando una frase…');
      startRecognition();
    }
    function installStyles(){
      if(document.getElementById('ig507-flow-css-20261021'))return;
      const st=document.createElement('style');st.id='ig507-flow-css-20261021';
      st.textContent=`
      .ig507 [hidden]{display:none!important}
      .ig507{--ig-blue:#0669e8;width:100%;max-width:1080px;padding:3px 5px!important;overflow-x:hidden!important}
      .ig507 .ig507-premium-header{display:block;max-width:480px;margin:0 auto!important;padding:10px 8px!important;background:#fff!important;border:0!important;border-radius:12px!important;box-shadow:none!important;text-align:center}
      .ig507 .ig507-badge{display:table!important;width:auto!important;font-size:11px!important;line-height:1.1!important;padding:5px 13px!important;margin:2px auto!important;min-height:0!important;border-radius:35px!important}
      .ig507 .ig507-robot-circle{height:clamp(102px,30vw,170px)!important;width:clamp(102px,30vw,170px)!important;margin:5px auto!important;box-shadow:none!important;filter:none!important;overflow:hidden;border-radius:50%}
      .ig507 .ig507-robot-circle video,.ig507 .ig507-robot-circle img{width:100%!important;height:100%!important;object-fit:cover!important}
      .ig507 .ig507-big-title{font-size:clamp(17px,5vw,24px)!important;line-height:1.07!important;margin:4px 0!important;padding:0!important;box-shadow:none!important;border:0!important;background:none!important}
      .ig507 .ig507-big-title span{display:block!important;font-size:1.13em!important;color:#056dff}
      .ig507 .ig507-speed{font-size:clamp(9px,2.5vw,12px)!important;padding:2px!important;border:0!important}
      .ig507 .ig507-subtitle{font-size:11px!important;margin:3px 0!important}
      .ig507 .ig507-logistica,.ig507 .ig507-postventa{font-size:11px!important;padding:4px 8px!important;margin:4px auto!important;box-shadow:none!important}
      .ig507 .ig507-main-actions{display:grid!important;grid-template-columns:repeat(3,minmax(0,1fr))!important;gap:5px!important;margin:8px 0!important}
      .ig507 .ig507-main-actions a{min-width:0!important;min-height:40px!important;padding:5px 3px!important;border-radius:9px!important;line-height:1.05!important;font-size:clamp(8px,2.4vw,11px)!important;box-shadow:none!important}
      .ig507 .ig507-start-banner{width:100%!important;min-height:56px!important;margin:5px 0!important;padding:7px!important;border:0!important;border-radius:10px!important;gap:7px!important;box-shadow:none!important;line-height:1.15!important}
      .ig507 .ig507-start-banner .mat{font-size:24px!important}
      .ig507 .ig507-start-banner .copy{padding-left:7px!important}
      .ig507 .ig507-start-banner b{font-size:clamp(9px,2.55vw,12px)!important}
      .ig507 .ig507-start-banner small{font-size:9px!important}
      .ig507 .ig507-start-banner .arrow{font-size:14px!important;padding:5px!important}
      .ig507 .ig507-start-main{width:100%;height:42px;border:0;border-radius:10px;background:linear-gradient(90deg,#008afc,#045ae6);font-weight:900;color:#fff;cursor:pointer;margin-top:5px;font-size:12px}
      .ig507 .ig-step{padding:5px 7px!important;margin:3px 0!important;border-radius:10px!important;box-shadow:none!important}
      .ig507 .ig-step-title{margin-bottom:3px!important;gap:6px!important}
      .ig507 .ig-step-title>b{width:24px!important;height:24px!important;flex-basis:24px!important;font-size:13px!important}
      .ig507 .ig-step-title h3{font-size:12px!important;line-height:1.1!important}
      .ig507 #ig507-paso-1 .ig-step-title small,.ig507 #ig507-paso-2 .ig-step-title small,.ig507 #ig507-paso-3 .ig-step-title small,.ig507 #ig507-paso-4 .ig-step-title small,.ig507 #ig507-paso-5 .ig-step-title small,.ig507 #ig507-paso-6 .ig-step-title small,.ig507 #ig507-paso-7 .ig-step-title small{display:none!important}
      .ig507 .ig-smart{display:flex!important;align-items:center;gap:4px!important;min-height:35px!important;padding:3px!important;background:#fff!important;border:2px solid #f500c5!important;border-radius:28px!important}
      .ig507 .ig-smart>b{flex-shrink:0;border-radius:20px;padding:5px 7px;color:#fff;background:linear-gradient(130deg,#ff00bd,#9c00ec);font-size:10px}
      .ig507 .ig-smart input{min-width:0!important;flex:1!important;font-size:11px!important;text-align:center;padding:4px 1px!important;min-height:27px!important}
      .ig507 .ig-smart button,.ig507 .ig507-step-mic,.ig507 .ig507-camera-button{width:30px!important;height:30px!important;min-width:30px!important;border-radius:9px!important;border:0!important;padding:0!important;color:#fff!important;background:linear-gradient(140deg,#ae00e4,#7000c9)!important;font-size:14px!important;display:inline-grid!important;place-items:center;cursor:pointer}
      .ig507 .ig507-step-mic{margin:0!important}
      .ig507 [data-ig-smart-msg]{font-size:9px!important;padding:3px!important;margin:3px 0!important;line-height:1.15!important}
      .ig507 .ig-six{display:grid!important;grid-template-columns:repeat(3,minmax(0,1fr))!important;gap:4px!important}
      .ig507 .ig-six label,.ig507 .ig-color-pair label{font-size:10px!important;min-width:0!important}
      .ig507 .ig-six select,.ig507 .ig-color-pair select{min-height:31px!important;height:31px!important;font-size:11px!important;font-weight:700!important;padding:3px 5px!important;border-radius:7px!important}
      .ig507 .ig-color-pair,.ig507 .ig-use,.ig507 .ig-needs,.ig507 .ig-priority,.ig507 .ig-materials,.ig507 .ig-ship-grid{grid-template-columns:repeat(2,minmax(0,1fr))!important;gap:4px!important}
      .ig507 .ig-use button,.ig507 .ig-needs button,.ig507 .ig-priority button,.ig507 .ig-materials button{min-height:32px!important;padding:3px 4px!important;font-size:10px!important;line-height:1.1!important;border-radius:7px!important}
      .ig507 .ig-materials button small{display:none!important}
      .ig507 .ig-ship-grid button{min-height:50px!important;align-items:flex-start!important;text-align:left!important;padding:4px!important;font-size:9px!important;line-height:1.1!important;border-radius:7px!important}
      .ig507 .ig-ship-grid button span{font-size:8px!important}
      .ig507 .ig-weight{font-size:9px!important;padding:2px 5px!important;margin:3px 0!important}
      .ig507 .ig-use .is-active{background:#0669e8!important;color:#fff!important;border-color:#0355a9!important}
      .ig507 .ig-needs .is-active{background:#7800de!important;color:#fff!important;border-color:#7800de!important}
      .ig507 .ig-priority .is-active{background:#ffb900!important;color:#001c3e!important;border-color:#0565dd!important}
      .ig507 .ig-materials [data-material="TPE 5D"].is-active{background:#15c933!important;color:#fff!important;border-color:#077021!important}
      .ig507 .ig-materials [data-material="Cuero Ecológico Artificial"].is-active{background:#ef0737!important;color:#fff!important;border-color:#b00024!important}
      .ig507 .ig-ship-grid .is-active{background:#031c42!important;color:#fff!important;border-color:#0084ef!important}
      .ig507 button.is-active{box-shadow:inset 0 0 0 1px #0064e8!important}
      .ig507 [data-confirm-vehicle]{height:37px!important;min-height:37px!important;margin:5px 0!important;padding:4px 6px!important;font-size:11px!important}
      .ig507 .ig507-small-clock{display:inline-block;padding:2px 8px;background:#ffe473;border-radius:7px;color:#29201c;font-size:10px;margin:2px 5px}
      .ig507 .ig507-photo-hint{margin:2px 0!important;padding:3px!important;font-size:9px!important;border-radius:6px;background:#eef8ff}

      /* GALERÍA INLINE DEL PASO 1: nunca toca body, header, megamenú ni Chat. */
      .ig507 .ig507-inline-photos{display:flex;align-items:center;gap:9px;width:100%;max-width:100%;min-width:0;margin:5px 0 4px;padding:8px;border:1px solid #efd3ff;border-radius:10px;background:linear-gradient(100deg,#f0eaff,#fff1fc 60%,#f5f0ff);box-sizing:border-box;overflow:hidden}
      .ig507 .ig507-inline-photo-title{display:flex;align-items:center;min-width:0;flex:0 1 42%;gap:6px;color:#211052}
      .ig507 .ig507-inline-photo-symbol{flex:none;background:#e0caff;border-radius:10px;padding:7px;font-size:17px;color:#6e19c9}
      .ig507 .ig507-inline-photo-heading{font-size:11px!important;line-height:1.1!important;font-weight:900!important;display:block!important;color:#231052!important}
      .ig507 .ig507-inline-photo-sub{display:block;font-size:9px!important;line-height:1.15!important;color:#5c5382!important;margin-top:3px}
      .ig507 .ig507-inline-photo-slots{flex:1 1 58%;min-width:0;display:flex;align-items:stretch;gap:4px;overflow-x:auto;scrollbar-width:thin;padding:2px 0 4px}
      .ig507 .ig507-inline-photo-slot{position:relative;flex:0 0 52px;width:52px;height:54px;min-width:52px;padding:0!important;border:1px dashed #bb9ff1!important;border-radius:8px!important;background:#ffffff9c!important;color:#8869bb!important;overflow:visible;cursor:pointer;display:grid;place-items:center}
      .ig507 .ig507-inline-photo-slot.is-filled{border:1px solid #dbb5ff!important;background:#fff!important;overflow:visible}
      .ig507 .ig507-inline-photo-slot.is-main{outline:2px solid #8b17e7!important;outline-offset:-2px}
      .ig507 .ig507-inline-photo-slot>img{display:block;width:100%;height:100%;object-fit:cover;border-radius:7px}
      .ig507 .ig507-inline-photo-slot .ig507-photo-plus{font-size:20px;line-height:1}
      .ig507 .ig507-inline-photo-remove{position:absolute!important;z-index:2;top:-5px;right:-5px;display:grid!important;place-items:center!important;min-width:18px!important;width:18px!important;height:18px!important;padding:0!important;border:0!important;border-radius:50%!important;background:#233254!important;color:#fff!important;font-size:11px!important;box-shadow:0 1px 4px #0003}
      .ig507 .ig507-inline-photo-cap{flex:0 0 39px;align-self:stretch;border:1px dashed #cdb3f2;border-radius:8px;display:grid;place-items:center;text-align:center;background:#faf5ff;color:#65469c;font-size:9px;font-weight:800;line-height:1.25;min-height:54px}
      .ig507 .ig507-camera-button{position:relative!important}
      .ig507 .ig507-photo-count{position:absolute;right:-4px;top:-5px;display:grid;place-items:center;width:15px;height:15px;border-radius:50%;background:#fb124f;color:#fff;font-size:9px;font-weight:800}
      .ig507 .ig507-inline-photos button:focus-visible{outline:2px solid #007aff!important;outline-offset:2px}
      @media(max-width:550px){.ig507 .ig507-inline-photos{display:block;padding:6px 6px 5px;margin-top:5px}.ig507 .ig507-inline-photo-title{width:100%;margin-bottom:5px}.ig507 .ig507-inline-photo-symbol{padding:4px 6px;font-size:14px}.ig507 .ig507-inline-photo-heading{font-size:10px!important}.ig507 .ig507-inline-photo-sub{font-size:9px!important}.ig507 .ig507-inline-photo-slots{width:100%;gap:5px;padding:2px 2px 5px}.ig507 .ig507-inline-photo-slot{flex-basis:52px;height:51px}.ig507 .ig507-inline-photo-cap{flex-basis:45px;min-height:51px}}

      .ig507 .ig507-photo-modal[hidden]{display:none!important}
      .ig507 .ig507-photo-modal{position:fixed!important;z-index:999999!important;inset:0;background:#0009;display:flex;align-items:center;justify-content:center;padding:16px}
      .ig507 .ig507-photo-panel{background:#fff;padding:12px;border-radius:12px;width:min(100%,420px);max-height:82vh;overflow:auto}
      .ig507 .ig507-photo-grid{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:6px;margin-top:8px}
      .ig507 .ig507-photo-grid figure{margin:0;position:relative;border:1px solid #b5cee8;border-radius:8px;overflow:hidden}
      .ig507 .ig507-photo-grid img{width:100%;aspect-ratio:1.2;object-fit:cover}
      .ig507 .ig507-photo-grid button{font-size:10px;min-height:28px;width:100%;border:0;background:#f1f7ff;color:#123f7c}
      .ig507 .ig507-product-row{display:flex!important;overflow-x:auto;gap:6px!important;padding:3px 0 5px!important}
      .ig507 .ig-product{padding:6px!important;min-width:0;scroll-snap-align:start}
      .ig507 .ig-product img{height:115px!important;object-fit:contain!important}
      .ig507 .ig-product h4{font-size:11px!important;line-height:1.2!important;min-height:27px!important}
      .ig507 .ig-product .ig-from{font-size:13px!important;font-weight:900!important;color:#056ac4!important}
      .ig507 .ig-product .vs{font-size:10px!important;height:36px!important;min-height:36px!important;padding:4px!important}
      .ig507 .ig-product .ig-pick{min-height:37px!important;font-size:10px!important;padding:5px 2px!important}
      .ig507 .ig-delivery-fields{grid-template-columns:repeat(2,minmax(0,1fr))!important;gap:5px!important}
      .ig507 .ig-delivery-fields input{font-size:11px!important;min-height:34px!important;padding:5px!important}
      .ig507 [data-generate-quote]{min-height:42px!important;margin:8px 0!important}
      .ig507 .ig-quote{padding:0!important;border:0!important;background:#fff}
      .ig507 .ig507-quote-frame{width:100%;max-width:1080px;margin:0 auto;position:relative;line-height:0}
      .ig507 .ig507-quote-frame>img{display:block;width:100%;height:auto;border-radius:7px}
      .ig507 .ig507-hit{position:absolute;z-index:2;background:transparent!important;border:0!important;border-radius:5px!important;cursor:pointer;padding:0!important;font-size:0!important;line-height:0!important}
      .ig507 .ig507-hit:focus-visible{outline:3px solid #efba18!important;outline-offset:-3px}
      @media(max-width:749px){.ig507 .ig-six{grid-template-columns:repeat(3,minmax(0,1fr))!important}.ig507 .ig507-robot-circle{width:clamp(102px,30vw,170px)!important;height:clamp(102px,30vw,170px)!important}}
      @media(max-width:345px){.ig507 .ig-use button,.ig507 .ig-needs button,.ig507 .ig-priority button{font-size:9px!important}.ig507 .ig-ship-grid button span{font-size:7px!important}}
      `;
      document.head.appendChild(st);
    }
    function header(){
      $('.ig507-premium-header')?.remove();
      const h=document.createElement('section');h.className='ig507-premium-header';
      h.innerHTML=`
        <div class="ig507-badge ia">🤖 ASISTENTE IA 24/7</div>
        <div class="ig507-badge time">⏱️ EN 60 SEGUNDOS 🐇</div>
        <div class="ig507-robot-circle">${CONFIG.video
          ? (/\.(?:mp4|webm|mov)(?:[?#]|$)/i.test(CONFIG.video)
              ? `<video src="${escapeHTML(CONFIG.video)}" autoplay muted playsinline loop preload="metadata" aria-label="Robot CAR MAT 29"></video>`
              : `<img src="${escapeHTML(CONFIG.video)}" alt="Robot CAR MAT 29" style="display:block;width:100%;height:100%;object-fit:cover;border-radius:50%">`)
          : '<span class="carmat29-robot-placeholder" role="img" aria-label="Imagen del robot CAR MAT 29 pendiente"><span aria-hidden="true">🤖</span><strong>CAR MAT 29</strong></span>'}</div>
        <h2 class="ig507-big-title">COTIZA EN TAN SOLO <span>60 SEGUNDOS ⚡</span></h2>
        <div class="ig507-speed">TE AHORRAMOS TIEMPO, <span>VENDEMOS VELOCIDAD</span></div>
        <p class="ig507-subtitle">Tu cotización personalizada, rápida e inteligente.</p>
        <div class="ig507-logistica">🌎 LOGÍSTICA GLOBAL</div>
        <div class="ig507-postventa">🛡️ ATENCIÓN POSTVENTA · ACTIVO 🟢</div>
        <div class="ig507-start-banner"><span class="mat" data-ig507-banner-mat>🚘</span><span class="copy"><b>DISEÑA TUS <em>ALFOMBRAS PERSONALIZADAS</em></b><small>Configura y cotiza tus tapetes para tu vehículo.</small></span><span class="arrow">❯</span></div>
        <button type="button" class="ig507-start-main" data-ig507-start>🚘 COMENZAR COTIZACIÓN ➜</button>`;
      const anchor=$('#ig507-paso-1')||$('.ig-step'); anchor?.parentNode.insertBefore(h,anchor);
      $('[data-ig507-start]',h).addEventListener('click',()=>{startTimer();showStage('form');scrollTo($('#ig507-paso-1'));});
      const img=$('.ig-product img');if(img?.src){const im=document.createElement('img');im.src=img.src;im.alt='Alfombras personalizadas';im.style.cssText='width:62px;height:45px;object-fit:contain';$('[data-ig507-banner-mat]',h).replaceChildren(im);}
      const smart=$('[data-ig-smart]');if(smart){
        const mic=document.createElement('button');mic.type='button';mic.className='ig507-step-mic';mic.textContent='🎙️';mic.setAttribute('aria-label','Dictar marca, modelo y año');mic.addEventListener('click',toggleVoice);
        smart.insertAdjacentElement('beforebegin',mic);
      }
      const badge=document.createElement('span');badge.className='ig507-small-clock';badge.innerHTML='<span data-ig507-clock>01:00</span>';
      const confirm=$('[data-confirm-vehicle]');if(confirm){confirm.textContent='🚘 GENERAR COTIZACIÓN ➜';confirm.insertAdjacentElement('afterend',badge);}
      $('[data-ig507-voice-status]')?.setAttribute('aria-live','polite');
    }
    function findVehicleRow(){
      return vehicleRows().find(r=>normalize(r.make_name)===normalize(state.brand)&&normalize(r.model_name)===normalize(state.model)&&(!r.year||String(r.year)===String(state.year)))||null;
    }
    let vehicleDebounce;
    function scheduleVehicleImage(){
      clearTimeout(vehicleDebounce);
      vehicleDebounce=setTimeout(()=>getVehicleImage(),650);
    }
    function imageURLFromPayload(d){
      if(typeof d==='string' && /^https?:\/\//.test(d))return d;
      if(!d||typeof d!=='object')return '';
      return d.image_url||d.imageUrl||d.url||d.image||d.src||d.result?.image_url||d.result?.url||d.images?.[0]?.url||'';
    }
    async function getVehicleImage(force=false){
      readManual();
      if(!state.brand||!state.model||!state.year)return '';
      if(state.uploadImage && !force)return state.uploadImage;
      const req=++imageRequest;
      const live=$('[data-ig507-vehicle]');
      if(live)live.textContent='Buscando fotografía de referencia…';
      const row=findVehicleRow();const known=row?.image_url||row?.imageUrl;
      if(known && !force){if(req===imageRequest)storeVehicleImage(known);return known;}
      const url=new URL(CONFIG.imageAPI);
      url.searchParams.set('q',`${state.brand} ${state.model} ${state.year} ${state.body||''} vehicle exterior`);
      url.searchParams.set('make',state.brand);url.searchParams.set('model',state.model);url.searchParams.set('year',state.year);
      const controller=new AbortController();const timeout=setTimeout(()=>controller.abort(),9500);
      try{
        const res=await fetch(url.toString(),{signal:controller.signal});
        if(!res.ok)throw Error('Imagen no encontrada');
        const ct=res.headers.get('content-type')||'';
        const result=ct.includes('image/')?url.toString():imageURLFromPayload(await res.json());
        if(!result)throw Error('Sin imagen');
        if(req===imageRequest)storeVehicleImage(result);
        return result;
      }catch{
        if(live&&req===imageRequest)live.textContent='No se encontró fotografía automática. Puedes añadir una foto.';
        return '';
      }finally{clearTimeout(timeout);}
    }
    function storeVehicleImage(src){
      if(!src)return;state.vehicleImage=src;
      const live=$('[data-ig507-vehicle]');
      if(live){live.replaceChildren();const im=document.createElement('img');im.src=src;im.alt='Vehículo de referencia';im.loading='lazy';im.style.cssText='width:125px;max-height:88px;object-fit:contain;border-radius:9px;';const caption=document.createElement('span');caption.textContent=`${state.brand} ${state.model} ${state.year} · Imagen de referencia`;live.append(im,caption);}
    }
    function setupVehicleUploader(){
      const smart=$('.ig-smart');if(!smart)return;
      // La barra superior conserva sus CINCO controles: IA, voz, texto, cámara y flecha.
      const camera=document.createElement('button');
      camera.type='button';camera.className='ig507-camera-button';camera.innerHTML='📷';
      camera.title='Subir 1 a 5 fotografías del vehículo';camera.setAttribute('aria-label','Subir hasta cinco fotos de tu vehículo');
      const arrow=$('[data-ig-smart-submit]',smart);smart.insertBefore(camera,arrow);
      const input=document.createElement('input');input.type='file';input.accept='image/*';input.multiple=true;
      // En móviles Android algunos selectores de archivos no abren inputs con display:none.
      // Dejamos el input fuera de la pantalla pero presente para recibir la acción táctil.
      input.style.cssText='position:absolute!important;left:-10000px!important;top:0!important;width:1px!important;height:1px!important;opacity:0!important;pointer-events:none!important';
      input.setAttribute('aria-label','Elegir fotografías del automóvil');root.append(input);
      const strip=document.createElement('div');strip.className='ig507-inline-photos';
      strip.setAttribute('aria-label','Añade hasta cinco fotografías opcionales de tu vehículo');
      strip.innerHTML=`<div class="ig507-inline-photo-title"><span class="ig507-inline-photo-symbol" aria-hidden="true">▣</span><div><strong class="ig507-inline-photo-heading">Añade 1–5 fotos de tu vehículo</strong><small class="ig507-inline-photo-sub">Exterior, interior o detalles (opcional)</small></div></div><div class="ig507-inline-photo-slots" data-ig507-inline-photo-slots></div>`;
      // La franja se muestra justo DEBAJO de la barra rosa, como el diseño aprobado.
      const photoAnchor=$('[data-ig507-photo-anchor]',root);
      if(photoAnchor)photoAnchor.replaceWith(strip);
      else smart.insertAdjacentElement('afterend',strip);
      const renderPhotos=()=>{
        const slots=$('[data-ig507-inline-photo-slots]',strip);slots.replaceChildren();
        for(let i=0;i<5;i++){
          const photo=state.photos[i];
          const cell=document.createElement('button');cell.type='button';
          cell.className='ig507-inline-photo-slot'+(photo?' is-filled':'')+(photo && i===state.mainPhoto?' is-main':'');
          if(photo){
            cell.title=i===state.mainPhoto?'Foto principal de la cotización':'Usar esta foto como principal';
            cell.setAttribute('aria-label',`Foto ${i+1}: ${photo.name||'Vehículo'}. Tocar para elegir como principal`);
            const thumb=document.createElement('img');thumb.src=photo.src;thumb.alt=`Foto ${i+1} del vehículo`;
            cell.append(thumb);
            // No alterar el orden de las fotos: drawVehiclePhotoGallery ya respeta mainPhoto.
            cell.addEventListener('click',()=>{state.mainPhoto=i;state.uploadImage=state.photos[i].src;state.quoteBlob=null;renderPhotos();});
            const remove=document.createElement('button');remove.type='button';remove.className='ig507-inline-photo-remove';
            remove.textContent='×';remove.setAttribute('aria-label',`Eliminar foto ${i+1}`);
            remove.addEventListener('click',e=>{
              e.stopPropagation();
              state.photos.splice(i,1);
              if(state.mainPhoto===i)state.mainPhoto=0;
              else if(i<state.mainPhoto)state.mainPhoto--;
              state.mainPhoto=Math.min(state.mainPhoto,Math.max(0,state.photos.length-1));
              state.uploadImage=state.photos[state.mainPhoto]?.src||'';
              state.quoteBlob=null;state.quoteURL='';
              renderPhotos();
            });
            cell.append(remove);
          }else{
            cell.innerHTML='<span class="ig507-photo-plus" aria-hidden="true">⊞</span>';
            cell.title='Añadir fotografías';cell.setAttribute('aria-label',`Añadir foto ${i+1} de un máximo de cinco`);
            cell.addEventListener('click',()=>openPhotoPicker());
          }
          slots.append(cell);
        }
        const cap=document.createElement('span');cap.className='ig507-inline-photo-cap';
        cap.innerHTML=`${state.photos.length}/5<br>fotos`;
        slots.append(cap);
        camera.replaceChildren(document.createTextNode('📷'));
        if(state.photos.length){
          const bubble=document.createElement('span');bubble.className='ig507-photo-count';
          bubble.textContent=String(state.photos.length);camera.append(bubble);
        }
        camera.disabled=state.photos.length>=5;
        camera.title=state.photos.length>=5?'Máximo cinco fotos. Elimina una para cambiarla.':'Subir fotografías del vehículo';
      };
      function openPhotoPicker(){
        if(state.photos.length>=5)return;
        // Restablecer value permite volver a elegir la misma foto si falló antes.
        input.value='';
        input.click();
      }
      camera.addEventListener('click',openPhotoPicker);
      const compress=async file=>{
        // Utiliza los bytes del archivo local sin enviarlos a servidores externos.
        const objectURL=URL.createObjectURL(file);
        try{
          // Una foto tomada por un teléfono puede tardar más de 3,8 s en decodificarse.
          const im=await loadImage(objectURL,25000);
          if(!im)throw Error('No se pudo abrir esta imagen; prueba JPG o PNG');
          const width=im.naturalWidth||im.width,height=im.naturalHeight||im.height;
          if(!width||!height)throw Error('La foto no tiene dimensiones legibles');
          const max=1400,scale=Math.min(1,max/Math.max(width,height));
          const canvas=document.createElement('canvas');
          canvas.width=Math.max(1,Math.round(width*scale));
          canvas.height=Math.max(1,Math.round(height*scale));
          const ctx=canvas.getContext('2d');
          if(!ctx)throw Error('No se pudo preparar la imagen');
          ctx.drawImage(im,0,0,canvas.width,canvas.height);
          return canvas.toDataURL('image/jpeg',0.78);
        }finally{URL.revokeObjectURL(objectURL);}
      };
      input.addEventListener('change',async()=>{
        const chosen=Array.from(input.files||[]).slice(0,Math.max(0,5-state.photos.length));
        if(!chosen.length)return;
        camera.disabled=true;
        const errors=[];
        for(const file of chosen){
          // Algunos teléfonos reportan MIME vacío para imágenes HEIC/HEIF.
          if(file.type && !file.type.startsWith('image/')){
            errors.push(file.name+': formato no reconocido');continue;
          }
          try{
            const src=await compress(file);
            state.photos.push({src,name:file.name});
            renderPhotos();
          }catch(e){
            console.warn('CAR MAT 29: fotografía no disponible',file.name,e);
            errors.push((file.name||'Fotografía')+': '+(e.message||'Error al abrir'));
          }
        }
        if(state.photos.length){
          state.mainPhoto=Math.min(state.mainPhoto,state.photos.length-1);
          state.uploadImage=state.photos[state.mainPhoto].src;
        }else state.uploadImage='';
        state.quoteBlob=null;state.quoteURL='';
        input.value='';renderPhotos();
        if(errors.length){
          alert('No se pudieron agregar '+errors.length+' foto(s).\n'+errors.slice(0,3).join('\n')+'\nPrueba con fotos JPG o PNG de tu galería.');
        }
      });
      renderPhotos();
    }
    function setupForm(){
      const brand=$('.mk'),model=$('.md');
      if(brand)populateModels(brand.value,model?.value||'',true);
      const defaults={seats:'5',trunk:'con',body:'Sedán',primary:'Negro',secondary:'Negro'};
      Object.entries(defaults).forEach(([k,v])=>setField(k,v,false));
      [['use','Uso diario'],['shipping','premium']].forEach(([k,v])=>choose(k,v,false));
      // Material no se selecciona solo: es una decisión obligatoria del comprador.
      Object.entries(F).forEach(([key,selector])=>{
        const el=$(selector);if(!el)return;
        el.addEventListener('change',()=>{
          const previous=state[key];state[key]=el.value||'';
          if(el.value)mark(key);else state.confirmed.delete(key);
          if(key==='brand' && previous!==el.value){state.model='';state.confirmed.delete('model');populateModels(el.value,'');}
          if(key==='model'&&state.model&& !state.confirmed.has('body')){const inferred=knownBody(state.model);if(inferred)setField('body',inferred,false);}
          if(['brand','model','year','body'].includes(key)){state.vehicleImage='';scheduleVehicleImage();}
          if(key==='seats')state.product=null;
          state.quoteBlob=null;
        });
      });
      for(const [selector,key,attr,multiple] of [
        ['.ig-use','use','v',false],['.ig-needs','needs','v',true],['.ig-priority','priority','v',false],
        ['.ig-materials','material','material',false],['.ig-ship-grid','shipping','ship',false]]){
        const container=$(selector);if(!container)continue;
        $$('button',container).forEach(btn=>btn.addEventListener('click',()=>{
          if(multiple){btn.classList.toggle('is-active');state.needs=$$('.is-active',container).map(b=>b.dataset.v);if(state.needs.length)mark(key);else state.confirmed.delete(key);}
          else{$$('button',container).forEach(b=>b.classList.toggle('is-active',b===btn));state[key]=btn.dataset[attr]||'';mark(key);}
          if(key==='material'||key==='shipping')state.product=null;
          state.quoteBlob=null;
        }));
      }
      const smart=$('[data-ig-smart]');const run=()=>{
        const txt=smart?.value.trim();if(txt){parseSpeech(txt);hint(`✓ ${[state.brand,state.model,state.year].filter(Boolean).join(' ') || 'Completa marca, modelo y año'}`);}
      };
      $('[data-ig-smart-submit]')?.addEventListener('click',run);
      smart?.addEventListener('keydown',e=>{if(e.key==='Enter'){e.preventDefault();run();}});
      $('[data-confirm-vehicle]')?.addEventListener('click',openCatalog);
      $$('.ig-pick').forEach(btn=>btn.addEventListener('click',()=>selectProduct(btn)));
      $('[data-generate-quote]')?.addEventListener('click',renderQuotation);
      $$('.ig-product .vs').forEach(sel=>sel.addEventListener('change',()=>{updateCardPrice(sel.closest('[data-product]'));}));
      $('.ig-delivery-fields')?.addEventListener('input',()=>{state.quoteBlob=null;});
      // UI: la decisión de material es requerida y los demás controles están precargados.
      if($('.ig-materials'))$('.ig-materials').setAttribute('aria-label','Selecciona material obligatorio');
    }
    // Navegación por etapas: una sola sección del cotizador visible.
    function showStage(stage){
      state.stage=stage;
      $$('.ig-step').forEach(el=>{
        let belongs='form';
        if(el.classList.contains('ig-products'))belongs='catalog';
        if(el.classList.contains('ig-delivery'))belongs='delivery';
        if(el.classList.contains('ig-quote'))belongs='quote';
        el.hidden=belongs!==stage;el.style.display=belongs===stage?'':'none';
      });
      const head=$('.ig507-premium-header');if(head){head.hidden=stage!=='welcome';head.style.display=stage==='welcome'?'':'none';}
      const confirm=$('[data-confirm-vehicle]');if(confirm){confirm.hidden=stage!=='form';confirm.style.display=stage==='form'?'':'none';}
      const clock=$('.ig507-small-clock');if(clock){clock.hidden=stage!=='form';clock.style.display=stage==='form'?'':'none';}
      // Evita el espacio de elementos heredados y permite desplazarse a la etapa activa.
      root.dataset.igStage=stage;
    }
    function seatVariant(card){
      const select=$('.vs',card);if(!select)return null;
      const target=Number(state.seats)||5;
      const options=$$('option',select).filter(o=>o.value&&!o.disabled&&o.dataset.available!=='0');
      const test=o=>{
        const text=normalize(o.dataset.title||o.textContent);
        const match=text.match(/(?:^|\s)(\d{1,2})\s*(?:asientos?|pasajeros?|plazas?)(?:\s|$)/);
        return match&&Number(match[1])===target;
      };
      return options.find(test)|| (options.length===1 && !/\d{1,2}\s*(?:asientos?|plazas?|pasajeros?)/.test(normalize(options[0].dataset.title||''))?options[0]:null);
    }
    function updateCardPrice(card){
      if(!card)return;const select=$('.vs',card),from=$('.ig-from',card),btn=$('.ig-pick',card);
      if(!select||!from)return;
      const option=select.selectedOptions?.[0],ok=Boolean(option?.value&&!option.disabled&&option.dataset.available!=='0');
      if(ok){
        const cents=Number(option.dataset.priceCents);
        from.textContent=Number.isFinite(cents)?`Desde ${money(cents/100)}`:'Precio por confirmar';
        if(btn){btn.disabled=false;btn.title='';}
      }else{
        from.textContent=`Selecciona variante de ${state.seats||5} asientos`;
        if(btn){btn.disabled=true;btn.title='Selecciona una variante disponible';}
      }
    }
    function openCatalog(){
      readManual();const products=$('.ig-products');if(!products){alert('No se encontró el catálogo en Liquid.');return;}
      if(!state.brand||!state.model||!state.year){hint('Selecciona marca, modelo y año para continuar.');showStage('form');scrollTo($('#ig507-paso-1'));return;}
      if(!state.material){hint('Selecciona TPE 5D o cuero ecológico en el paso 4.');showStage('form');scrollTo($('#ig507-paso-4'));return;}
      const catalogs=$$('.ig-catalog',products);
      catalogs.forEach(c=>c.hidden=normalize(c.dataset.cat)!==normalize(state.material));
      for(const c of catalogs.filter(c=>!c.hidden)){
        const cards=$$('.ig-product',c);
        if(cards.length&&!$('.ig507-product-row',c)){
          const per=Math.ceil(cards.length/3);
          for(let n=0;n<3;n++){
            const part=cards.slice(n*per,(n+1)*per);if(!part.length)continue;
            const row=document.createElement('div');row.className='ig507-product-row';part.forEach(card=>row.append(card));c.append(row);
          }
        }
        for(const card of cards){
          const select=$('.vs',card);if(!select)continue;
          const matched=seatVariant(card);
          select.value=matched?.value||'';
          updateCardPrice(card);
        }
      }
      showStage('catalog');scrollTo(products);
    }
    function selectProduct(button){
      const card=button.closest('[data-product]');if(!card)return;
      const select=$('.vs',card),option=select?.selectedOptions?.[0];
      if(!option?.value||option.disabled||option.dataset.available==='0'){
        alert(`Selecciona una variante de ${state.seats||5} asientos disponible.`);return;
      }
      // Si cambia la variante en el catálogo, los asientos de la cotización deben coincidir.
      const seatsMatch=normalize(option.dataset.title||option.textContent).match(/(?:^|\s)(\d{1,2})\s*(?:asientos?|pasajeros?|plazas?)(?:\s|$)/);
      if(seatsMatch&&Number(seatsMatch[1])>=2&&Number(seatsMatch[1])<=15)setField('seats',seatsMatch[1]);
      const thumbnail=$('img',card);
      const candidates=[option.dataset.image,card.dataset.image,
        thumbnail?.currentSrc,thumbnail?.src,thumbnail?.dataset.src,
        $('source',card)?.srcset?.split(',')[0]?.trim().split(' ')[0]]
        .map(src=>String(src||'').trim())
        .filter(Boolean)
        .map(src=>{try{return new URL(src,location.href).href;}catch{return src;}});
      const imageCandidates=[...new Set(candidates)];
      state.product={title:card.dataset.title||$('h4',card)?.textContent?.trim()||'Alfombras personalizadas',
        variant:option.dataset.title||option.textContent.trim(),id:option.value,
        priceCents:Number(option.dataset.priceCents||0),image:imageCandidates[0]||'',imageCandidates};
      if(!state.product.priceCents){alert('La variante no tiene un precio válido publicado.');state.product=null;return;}
      state.quoteBlob=null;showStage('delivery');scrollTo($('[data-delivery-section]'));
    }
    function details(){
      const d={};$$('.ig-delivery-fields input').forEach(i=>{d[i.name]=i.value.trim()||'Pendiente por completar';});return d;
    }
    function shippingCost(){
      if(!(state.shipping in CONFIG.shipping))return null;
      if(state.shipping==='premium')return 0;
      // Las tarifas están definidas en USD. Nunca mezclarlas con EUR/MXN/etc.
      return safeCurrency==='USD'?CONFIG.shipping[state.shipping]*CONFIG.estimateKg:null;
    }
    function pricing(){
      const product=state.product?.priceCents?state.product.priceCents/100:null;
      const shipping=shippingCost();
      return {product,shipping,total:product===null||shipping===null?null:product+shipping};
    }
    function summaryRows(){
      const p=state.product;const sh=state.shipping;const vehicle=[state.brand,state.model].filter(Boolean).join(' ');
      return [
        ['🚘','Vehículo',vehicle||'Pendiente'],['📅','Año',state.year||'Pendiente'],['💺','Asientos',state.seats||'Pendiente'],
        ['🧳','Maletero',state.trunk==='con'?'Con alfombra de maletero':state.trunk==='sin'?'Sin maletero':'Por definir'],
        ['▤','Material',state.material||'Pendiente'],['🎨','Colores',[state.primary,state.secondary].filter(Boolean).join(' + ')||'Pendiente'],
        ['🚗','Uso',state.use||'Pendiente'],['📦','Producto',p?.title||'Pendiente'],
        ['⚙️','Variante',p?.variant||'Pendiente'],['🚚','Envío',CONFIG.shippingLabels[sh]||'Pendiente'],
        ['◷','Entrega',CONFIG.shippingDays[sh]||'Por confirmar']
      ];
    }
    function whatsappText(){
      const price=pricing();return `Hola, quiero confirmar mi cotización personalizada de CAR MAT 29.\nVehículo: ${[state.brand,state.model,state.year].filter(Boolean).join(' ')}.\nAsientos: ${state.seats||'Pendiente'}. Colores: ${state.primary||'Pendiente'} + ${state.secondary||'Pendiente'}.\nMaterial: ${state.material||'Pendiente'}. Maletero: ${state.trunk||'Pendiente'}.\nProducto: ${state.product?.title||'Pendiente'}. Variante: ${state.product?.variant||'Pendiente'}.\nEnvío: ${CONFIG.shippingLabels[state.shipping]||'Pendiente'}.\nTotal estimado: ${price.total===null?'Por confirmar':money(price.total)}.\nAdjunto la cotización visual. Por favor, ayúdame a confirmar mi pedido.`;
    }
    function trimTo(ctx,text,maxW){let t=String(text);while(t.length>1&&ctx.measureText(t).width>maxW)t=t.slice(0,-2)+'…';return t;}
    function drawWrapped(ctx,text,x,y,maxWidth,lineHeight,maxLines=2){
      const words=String(text).split(/\s+/);let lines=[],line='';
      for(const w of words){const candidate=line?line+' '+w:w;if(ctx.measureText(candidate).width>maxWidth&&line){lines.push(line);line=w;}else line=candidate;}
      if(line)lines.push(line);lines=lines.slice(0,maxLines);lines.forEach((str,i)=>ctx.fillText(trimTo(ctx,str,maxWidth),x,y+i*lineHeight));return y+lines.length*lineHeight;
    }
    async function loadImage(src,timeoutMs){
      if(!src)return null;
      return new Promise(resolve=>{
        const im=new Image();
        if(/^https?:/i.test(src))im.crossOrigin='anonymous';
        const timeout=timeoutMs||(/^(blob:|data:)/i.test(src)?25000:12000);
        let settled=false,timer;
        const finish=v=>{
          if(settled)return;
          settled=true;clearTimeout(timer);im.onload=null;im.onerror=null;resolve(v);
        };
        im.onload=()=>finish(im);im.onerror=()=>finish(null);
        timer=setTimeout(()=>finish(null),timeout);
        im.src=src;
      });
    }
    async function loadFirstImage(srcList){
      const list=Array.isArray(srcList)?srcList:[srcList];
      for(const src of list){
        const result=await loadImage(src);
        if(result)return result;
      }
      return null;
    }
    function fitImage(ctx,im,x,y,w,h){
      if(!im)return false;const scale=Math.min(w/im.naturalWidth,h/im.naturalHeight);
      const dw=im.naturalWidth*scale,dh=im.naturalHeight*scale;
      ctx.drawImage(im,x+(w-dw)/2,y+(h-dh)/2,dw,dh);return true;
    }
    // Encuadra la fotografía REAL del producto sin deformarla ni cortar sus piezas.
    // Cuando Shopify aporta mucho espacio blanco, primero recorta SOLO ese margen.
    // Las fotos con fondos de escenas o personas siguen usando "contain" normal.
    function fitProductImage(ctx,im,x,y,w,h){
      if(!im)return false;
      const iw=im.naturalWidth,ih=im.naturalHeight;
      if(!iw||!ih)return false;
      let sx=0,sy=0,sw=iw,sh=ih;
      try{
        const maxSide=240,ratio=Math.min(1,maxSide/Math.max(iw,ih));
        const cw=Math.max(1,Math.round(iw*ratio)),ch=Math.max(1,Math.round(ih*ratio));
        const probe=document.createElement('canvas');probe.width=cw;probe.height=ch;
        const pg=probe.getContext('2d',{willReadFrequently:true});
        pg.drawImage(im,0,0,cw,ch);
        const raw=pg.getImageData(0,0,cw,ch).data;
        let left=cw,top=ch,right=-1,bottom=-1,count=0;
        for(let py=0;py<ch;py++)for(let px=0;px<cw;px++){
          const z=(py*cw+px)*4,r=raw[z],g=raw[z+1],b=raw[z+2],a=raw[z+3];
          if(a<35)continue;
          // Ignorar exclusivamente fondo blanco/gris casi blanco.
          if(r>=242&&g>=242&&b>=242&&Math.max(r,g,b)-Math.min(r,g,b)<22)continue;
          count++;left=Math.min(left,px);right=Math.max(right,px);
          top=Math.min(top,py);bottom=Math.max(bottom,py);
        }
        if(count>cw*ch*0.008&&right>=left&&bottom>=top){
          const padX=Math.max(4,Math.round((right-left+1)*0.045));
          const padY=Math.max(4,Math.round((bottom-top+1)*0.045));
          left=Math.max(0,left-padX);right=Math.min(cw-1,right+padX);
          top=Math.max(0,top-padY);bottom=Math.min(ch-1,bottom+padY);
          // Solo recortar si se detectó realmente margen sobrante.
          if((right-left+1)<cw*0.94||(bottom-top+1)<ch*0.94){
            sx=left/cw*iw;sy=top/ch*ih;
            sw=(right-left+1)/cw*iw;sh=(bottom-top+1)/ch*ih;
          }
        }
      }catch(error){
        // CORS o fotografía no procesable: conserva la imagen original.
        sx=0;sy=0;sw=iw;sh=ih;
      }
      const scale=Math.min(w/sw,h/sh),dw=sw*scale,dh=sh*scale;
      ctx.drawImage(im,sx,sy,sw,sh,x+(w-dw)/2,y+(h-dh)/2,dw,dh);
      return true;
    }
    // ÚNICO CAMBIO DE LA COTIZACIÓN: distribuir 1 a 5 fotos del cliente
    // dentro del recuadro existente «VEHÍCULO DE REFERENCIA».
    // No cambia las dimensiones del PNG, la plantilla ni las otras secciones.
    async function drawVehiclePhotoGallery(ctx,x,y,w,h,fallbackImage){
      const uploaded=state.photos.slice(0,5);
      if(!uploaded.length) return fitImage(ctx,fallbackImage,x,y,w,h);

      // Respetar la imagen «Principal» elegida por el cliente.
      const main=Math.min(Math.max(Number(state.mainPhoto)||0,0),uploaded.length-1);
      const ordered=[uploaded[main],...uploaded.filter((_,i)=>i!==main)];
      const loaded=await Promise.all(ordered.map(p=>loadImage(p.src)));
      const images=loaded.filter(im=>im && im.naturalWidth>0 && im.naturalHeight>0);
      if(!images.length) return fitImage(ctx,fallbackImage,x,y,w,h);

      const gap=5,midW=(w-gap)/2,midH=(h-gap)/2;
      const tile=(x,y,w,h)=>({x,y,w,h});
      let tiles;
      if(images.length===1){
        tiles=[tile(x,y,w,h)];
      }else if(images.length===2){
        tiles=[tile(x,y,midW,h),tile(x+midW+gap,y,midW,h)];
      }else if(images.length===3){
        const large=(w-gap)*0.59,small=w-gap-large;
        tiles=[tile(x,y,large,h),tile(x+large+gap,y,small,midH),tile(x+large+gap,y+midH+gap,small,midH)];
      }else if(images.length===4){
        tiles=[tile(x,y,midW,midH),tile(x+midW+gap,y,midW,midH),
          tile(x,y+midH+gap,midW,midH),tile(x+midW+gap,y+midH+gap,midW,midH)];
      }else{
        const large=(w-gap)*0.52,remaining=w-gap-large,smallW=(remaining-gap)/2;
        tiles=[tile(x,y,large,h),
          tile(x+large+gap,y,smallW,midH),
          tile(x+large+gap+smallW+gap,y,smallW,midH),
          tile(x+large+gap,y+midH+gap,smallW,midH),
          tile(x+large+gap+smallW+gap,y+midH+gap,smallW,midH)];
      }

      images.forEach((im,i)=>{
        const t=tiles[i],iw=im.naturalWidth,ih=im.naturalHeight;
        // «cover» conserva las proporciones: llena la celda sin deformar la foto.
        const targetAspect=t.w/t.h,imageAspect=iw/ih;
        let sx=0,sy=0,sw=iw,sh=ih;
        if(imageAspect>targetAspect){sw=ih*targetAspect;sx=(iw-sw)/2;}
        else{sh=iw/targetAspect;sy=(ih-sh)/2;}
        ctx.save();ctx.beginPath();
        if(typeof ctx.roundRect==='function')ctx.roundRect(t.x,t.y,t.w,t.h,6);
        else ctx.rect(t.x,t.y,t.w,t.h);
        ctx.clip();ctx.drawImage(im,sx,sy,sw,sh,t.x,t.y,t.w,t.h);
        ctx.restore();
      });
      return true;
    }

    async function generateCanvas(){
      // Una sola imagen con más superficie para fotografías y textos legibles.
      const {width:W,height:H,photoExtra:PHOTO_EXTRA}=QUOTE_LAYOUT;
      const c=document.createElement('canvas');c.width=W;c.height=H;
      const g=c.getContext('2d');if(!g)throw Error('Este navegador no puede crear la imagen');
      // PALETA APROBADA: se aplica EXCLUSIVAMENTE dentro del PNG de la cotización.
      // Ningún cambio de lógica, datos, fotografías, posiciones de botones ni altura del canvas.
      const navy='#061c49',blue='#052b89',azure='#056de6',red='#e90029',green='#00842e';
      const palette={electric:'#086efe',cyan:'#00d9f4',pink:'#f018b8',violet:'#8200ef',
        lime:'#00c744',orange:'#ff8c00',gold:'#ffcb25',red:'#f80a40',dark:'#05275e'};
      g.fillStyle='#ffffff';g.fillRect(0,0,W,H);
      const box=(x,y,w,h,fill,stroke='',r=8)=>{
        g.beginPath();if(g.roundRect)g.roundRect(x,y,w,h,r);else g.rect(x,y,w,h);
        g.fillStyle=fill;g.fill();if(stroke){g.strokeStyle=stroke;g.lineWidth=1.6;g.stroke();}
      };
      // Rectángulos con degradado, recorte redondeado y bordes multicolores.
      const gradientBox=(x,y,w,h,stops,stroke='',r=8)=>{
        const grad=g.createLinearGradient(x,y,x+w,y+h*0.23);
        stops.forEach(([at,c])=>grad.addColorStop(at,c));
        g.beginPath();if(g.roundRect)g.roundRect(x,y,w,h,r);else g.rect(x,y,w,h);
        g.fillStyle=grad;g.fill();
        if(stroke){g.strokeStyle=stroke;g.lineWidth=2;g.stroke();}
      };
      const rainbowBorder=(x,y,w,h,r=10)=>{
        const grad=g.createLinearGradient(x,y,x+w,y);
        [[0,palette.cyan],[0.35,palette.electric],[0.72,palette.violet],[1,palette.pink]]
          .forEach(([at,c])=>grad.addColorStop(at,c));
        g.save();g.beginPath();if(g.roundRect)g.roundRect(x,y,w,h,r);else g.rect(x,y,w,h);
        g.lineWidth=3;g.strokeStyle=grad;g.stroke();g.restore();
      };
      const streaks=(x,y,w,h,color='rgba(255,255,255,.24)',right=true)=>{
        // Franjas diagonales decorativas, confinadas a los extremos del panel.
        g.save();g.beginPath();g.rect(x,y,w,h);g.clip();g.fillStyle=color;
        const side=right?x+w-75:x+12;
        for(let i=0;i<3;i++){
          const sx=side+i*15;
          g.beginPath();g.moveTo(sx,y);g.lineTo(sx+17,y);g.lineTo(sx-30,y+h);
          g.lineTo(sx-47,y+h);g.closePath();g.fill();
        }
        g.restore();
      };
      const write=(value,x,y,size=18,color=navy,bold=false,align='left')=>{
        g.font=`${bold?'700 ':'400 '}${size}px Arial, sans-serif`;g.fillStyle=color;g.textAlign=align;
        g.fillText(String(value??''),x,y);g.textAlign='left';
      };
      const fitted=(value,x,y,maxWidth,size=19,color=navy,bold=false,align='left',min=12)=>{
        // Nunca dibujar fuera del panel: reducir lo mínimo necesario;
        // en textos excepcionalmente largos, comprimir su ancho sin cortarlos.
        const content=String(value??'');let font=size;
        while(font>min){
          g.font=`${bold?'700 ':'400 '}${font}px Arial`;
          if(g.measureText(content).width<=maxWidth)break;
          font--;
        }
        g.font=`${bold?'700 ':'400 '}${font}px Arial`;
        g.fillStyle=color;g.textAlign=align;
        g.fillText(content,x,y,maxWidth);
        g.textAlign='left';
      };
      const wrapped=(str,x,y,maxWidth,size=21,leading=27,maxLines=2,color=navy,bold=false)=>{
        g.font=`${bold?'700 ':'400 '}${size}px Arial`;
        const words=String(str||'').split(/\s+/),lines=[];let line='';
        for(const word of words){const test=line?line+' '+word:word;
          if(line&&g.measureText(test).width>maxWidth){lines.push(line);line=word;}else line=test;
        }
        if(line)lines.push(line);
        lines.slice(0,maxLines).forEach((t,i)=>fitted(t,x,y+i*leading,maxWidth,size,color,bold,'left',Math.max(12,size-4)));
      };
      // Encabezado principal
      gradientBox(24,12,1032,129,[[0,'#ffffff'],[.76,'#ffffff'],[.89,'#e9faff'],[1,'#f7e9ff']],'#80dcea',10);
      streaks(810,12,245,129,'rgba(0,166,255,.15)');
      rainbowBorder(24,12,1032,129,10);
      // Cargar en paralelo: ninguna búsqueda de imágenes debe retrasar innecesariamente el PNG.
      const [logo,car,mat]=await Promise.all([
        loadImage(CONFIG.logo),
        loadImage(state.uploadImage||state.vehicleImage),
        loadFirstImage(state.product?.imageCandidates?.length ? state.product.imageCandidates : state.product?.image)
      ]);
      if(!fitImage(g,logo,35,15,142,121)){
        box(38,19,134,112,'#0347a0','',52);write('CAR MAT',105,77,18,'#ffffff',true,'center');write('29',105,100,25,'#ffffff',true,'center');
      }
      const title=state.product?.title||'ALFOMBRAS PERSONALIZADAS PREMIUM';
      const label=title.replace(/\s+/g,' ').trim();
      g.font='700 31px Arial';
      const pieces=label.split(' '),lines=[];let ln='';
      for(const w of pieces){const candidate=ln?ln+' '+w:w;if(g.measureText(candidate).width>725&&ln){lines.push(ln);ln=w;}else ln=candidate;}
      if(ln)lines.push(ln);
      const headerLines=lines.slice(0,2);
      if(lines.length>2){headerLines[1]=headerLines[1].slice(0,Math.max(8,headerLines[1].length-2))+'…';}
      headerLines.forEach((t,i)=>fitted(t,192,48+i*34,740,31,blue,true,'left',23));
      write('Cotización personalizada',405,116,30,red,true,'center');
      gradientBox(935,20,105,100,[[0,'#0b0b13'],[.5,'#111111'],[1,'#221500']],'#ebc15a',48);write('★',987,47,26,'#e8c369',true,'center');
      write('CALIDAD',987,75,17,'#e8c369',true,'center');write('PREMIUM',987,98,17,'#e8c369',true,'center');
      gradientBox(25,147,1030,47,[[0,'#12e93c'],[.36,'#03ad35'],[.69,'#06c738'],[1,'#6cf221']],'#38de6b',9);
      streaks(40,147,120,47,'rgba(255,255,255,.18)',false);
      streaks(925,147,125,47,'rgba(255,255,90,.27)');
      write('✓ TU COTIZACIÓN ESTÁ LISTA',540,179,34,'#ffffff',true,'center');
      // Resumen de las 13 características
      const rows=summaryRows();box(25,200,1030,425,'#ffffff','#42bfff',9);
      const symbolColors=[palette.red,palette.orange,palette.electric,palette.cyan,
        palette.violet,palette.orange,palette.red,palette.lime,palette.violet,
        palette.orange,palette.lime,palette.orange,palette.pink];
      rows.forEach(([symbol,key,value],i)=>{
        const y=207+i*31.5;
        if(i%2===0)gradientBox(31,y,1018,31,[[0,'#e9f5ff'],[.64,'#edf7ff'],[1,'#e1efff']],'',0);
        write(symbol,43,y+22,20,symbolColors[i]||blue,true);
        write(key,105,y+22,24,navy,false);
        fitted(value,1038,y+22,745,24,navy,true,'right',17);
      });
      // Datos de entrega opcionales (paso 6) en dos columnas
      gradientBox(25,631,1030,214,[[0,'#ffffff'],[.70,'#fffefa'],[1,'#fffdf0']],'#f5ac27',9);
      gradientBox(25,631,1030,45,[[0,'#ffb419'],[.25,'#fc3439'],[.51,'#f86b09'],[.81,'#ffd936'],[1,'#fb4238']],'',9);
      streaks(860,631,195,45,'rgba(255,255,255,.26)');
      write('🚚 DATOS DE ENTREGA',43,665,30,'#ffffff',true);
      write('(Opcionales)',427,665,20,'#ffffff',false);
      const d=details();
      const keys=[['nombre','Nombre'],['apellido','Apellido'],['identificacion','DNI / Identificación'],['pais','País'],['provincia','Provincia / Estado'],['ciudad','Ciudad'],['codigo_postal','Código postal'],['direccion','Dirección completa'],['telefono','Teléfono'],['correo','Correo electrónico'],['metodo_pago','Método de pago']];
      keys.forEach(([key,label],i)=>{
        const col=i<6?0:1,row=col===0?i:i-6,x=43+col*514,y=697+row*24;
        fitted(label+':',x,y,202,21,navy,false,'left',17);
        const value=d[key]||'Pendiente por completar';
        const pending=value==='Pendiente por completar';
        box(x+205,y-19,286,23,pending?'#fff2d8':'#e8f6ff','',4);
        fitted(value,x+212,y,271,20,pending?'#926924':navy,!pending,'left',16);
      });
      // Fotografías del auto y de la variante seleccionada en dos paneles
      gradientBox(25,851,506,319+PHOTO_EXTRA,[[0,'#ffffff'],[1,'#fff2f9']],'#f527a5',9);
      gradientBox(540,851,515,319+PHOTO_EXTRA,[[0,'#ffffff'],[1,'#f9eaff']],'#9b25f2',9);
      gradientBox(25,851,506,46,[[0,'#ff123c'],[.66,'#e91694'],[1,'#fc56be']],'',9);
      gradientBox(540,851,515,46,[[0,'#a900f5'],[.62,'#7000d6'],[1,'#eb1ed3']],'',9);
      streaks(425,851,100,46,'rgba(255,255,255,.26)');
      streaks(955,851,100,46,'rgba(255,255,255,.24)');
      write('🚘 VEHÍCULO DE REFERENCIA',39,885,27,'#ffffff',true);
      write('▤ ALFOMBRA DE REFERENCIA',554,885,27,'#ffffff',true);
      box(37,897,480,240+PHOTO_EXTRA,'#f5f9fc','',6);box(552,897,490,240+PHOTO_EXTRA,'#f5f9fc','',6);
      if(!await drawVehiclePhotoGallery(g,39,901,476,230+PHOTO_EXTRA,car)){
        write('Fotografía de tu automóvil',278,1084,23,'#68798a',true,'center');
        write('Opcional / pendiente',278,1118,20,'#718398',false,'center');
      }
      if(!fitProductImage(g,mat,553,901,488,230+PHOTO_EXTRA)){
        console.warn('CAR MAT 29: no se pudo leer una imagen de producto desde Shopify.', state.product?.imageCandidates||[]);
        write('Fotografía del producto',797,1084,23,'#68798a',true,'center');
        write('No disponible',797,1118,20,'#718398',false,'center');
      }
      write('Imagen de referencia',280,1159+PHOTO_EXTRA,16,'#648096',false,'center');
      write('Imagen del producto elegido',796,1159+PHOTO_EXTRA,16,'#648096',false,'center');
      // La sección inferior se desplaza para dar espacio real a las fotos.
      g.save();g.translate(0,PHOTO_EXTRA);
      // Mensaje de marca
      gradientBox(25,1176,1030,75,[[0,'#0931b7'],[.19,'#02a4fa'],[.37,'#05336d'],[.78,'#082b79'],[1,'#026df0']],'#e8b840',9);
      streaks(30,1176,105,75,'rgba(0,238,255,.42)',false);
      streaks(947,1176,105,75,'rgba(0,238,255,.42)');
      write('★ TU AUTO ES PARTE DE TU HISTORIA',540,1207,31,'#ffd458',true,'center');
      fitted('Cada detalle cuenta: protege su interior con el cuidado y el estilo que elegiste.',540,1234,990,21,'#ffffff',false,'center',18);
      // Total en la moneda real de la tienda/mercado
      const p=pricing();gradientBox(25,1257,1030,106,[[0,'#0055cf'],[.35,'#064a9e'],[.62,'#05204e'],[.9,'#056bea'],[1,'#067af6']],'#00b9f7',9);
      g.save();g.beginPath();g.moveTo(548,1273);g.lineTo(548,1346);g.strokeStyle='rgba(255,255,255,.6)';g.lineWidth=2;g.stroke();g.restore();
      fitted('Producto: '+(p.product===null?'Por confirmar':money(p.product)),43,1291,980,28,'#ffffff',false);
      const shipMsg=p.shipping!==null?money(p.shipping):`${(CONFIG.shipping[state.shipping]*CONFIG.estimateKg).toFixed(2)} USD (conversión por confirmar)`;
      fitted('Envío: '+shipMsg,43,1322,980,27,'#ffffff',false);
      fitted('TOTAL: '+(p.total===null?'Por confirmar en '+safeCurrency:money(p.total)),1033,1352,950,41,'#ffffff',true,'right',29);
      // Mensaje final y botones dentro del único PNG
      gradientBox(25,1369,1030,73,[[0,'#e0f6ff'],[.5,'#f0f8ff'],[1,'#d8f7ff']],'#4bc5ff',9);
      streaks(32,1369,140,73,'rgba(41,163,247,.16)',false);
      streaks(944,1369,110,73,'rgba(41,163,247,.16)');
      write('TU ELECCIÓN, LISTA PARA CONFIRMAR',540,1399,29,blue,true,'center');
      fitted(`Auto: ${state.brand} ${state.model} ${state.year} · ${state.seats} asientos · ${state.material}`,540,1424,990,23,navy,false,'center',18);
      gradientBox(25,1446,1030,53,[[0,'#fff98a'],[.5,'#fff3a1'],[1,'#ffed48']],'',10);
      fitted('¡TU DISEÑO ESTÁ LISTO PARA HACERSE REALIDAD!',540,1468,1020,28,red,true,'center',24);
      fitted('👇 PULSA UNO DE LOS DOS BOTONES PARA CONTINUAR CON TU COMPRA 👇',540,1492,945,18,'#232017',true,'center',14);
      // Botones principales destacados: dos columnas iguales y superficie táctil amplia.
      g.save();g.shadowColor='#04184955';g.shadowBlur=14;g.shadowOffsetY=3;
      gradientBox(26,1504,508,82,[[0,'#e9041b'],[.58,'#fa123d'],[1,'#c90022']],'',11);
      gradientBox(542,1504,512,82,[[0,'#04df65'],[.59,'#00bb36'],[1,'#00a925']],'',11);g.restore();
      fitted('💳 PAGAR AHORA CON TARJETA',280,1548,480,30,'#ffffff',true,'center',23);
      write('Crédito o débito',280,1571,20,'#ffffff',false,'center');
      fitted('💬 PAGO ALTERNATIVO',798,1548,490,31,'#ffffff',true,'center',23);
      fitted('Vía WhatsApp · Atención inmediata',798,1571,490,20,'#ffffff',false,'center',18);
      gradientBox(26,1592,332,46,[[0,'#0c53ca'],[1,'#055dc5']],'',9);
      gradientBox(366,1592,334,46,[[0,'#045be9'],[1,'#00a6ff']],'',9);
      gradientBox(708,1592,346,46,[[0,'#9710e9'],[1,'#5e00cb']],'',9);
      fitted('⬇ DESCARGAR COTIZACIÓN',192,1621,312,18,'#ffffff',true,'center',15);
      fitted('◉ COMPARTIR WHATSAPP',532,1621,314,18,'#ffffff',true,'center',15);
      fitted('✉ RECIBIR POR CORREO',882,1621,327,18,'#ffffff',true,'center',15);
      fitted(CONFIG.website,31,1659,490,25,blue,true,'left',19);
      fitted('WhatsApp: +507 6442-6565',1047,1659,485,25,green,true,'right',19);
      g.restore();
      return c;
    }
    function canvasToBlob(c){return new Promise((resolve,reject)=>c.toBlob(b=>b?resolve(b):reject(new Error('No se generó imagen')),'image/png'));}
    async function prepareQuote(){
      if(state.quoteBlob)return state.quoteBlob;
      const c=await generateCanvas();const blob=await canvasToBlob(c);
      state.quoteBlob=blob;if(state.quoteURL)URL.revokeObjectURL(state.quoteURL);state.quoteURL=URL.createObjectURL(blob);
      return blob;
    }
    function downloadFile(blob,name='CAR-MAT-29-Cotizacion-Personalizada.png'){
      const url=URL.createObjectURL(blob);const a=document.createElement('a');a.href=url;a.download=name;document.body.append(a);a.click();a.remove();setTimeout(()=>URL.revokeObjectURL(url),30000);
    }
    async function shareQuote(openWhatsApp=true){
      const blob=await prepareQuote();const file=new File([blob],'CAR-MAT-29-Cotizacion-Personalizada.png',{type:'image/png'});
      try{if(navigator.share && (!navigator.canShare||navigator.canShare({files:[file]}))){
        await navigator.share({files:[file],title:'Cotización CAR MAT 29',text:state.quoteText});return;
      }}catch(e){if(e?.name==='AbortError')return;}
      downloadFile(blob);
      if(openWhatsApp)window.open(CONFIG.whatsapp,'_blank','noopener');
      alert('Se descargó la imagen. Adjúntala en WhatsApp: el enlace web no permite adjuntar archivos automáticamente.');
    }
    // SHOPIFY: agregar la variante REAL al carrito antes de iniciar la compra.
    // Abrir un enlace de pago externo no registra por sí solo un pedido Shopify.
    function cartProperties(){
      return {
        'Vehículo': [state.brand,state.model,state.year].filter(Boolean).join(' '),
        'Carrocería': state.body || 'Pendiente',
        'Asientos': String(state.seats||5),
        'Maletero': state.trunk==='con'?'Con alfombra':state.trunk==='sin'?'Sin alfombra':'Por confirmar',
        'Material': state.material||'Por confirmar',
        'Color principal': state.primary||'Por confirmar',
        'Color secundario': state.secondary||'Por confirmar',
        'Uso': state.use||'Por confirmar',
        'Envío solicitado': CONFIG.shippingLabels[state.shipping]||'Por confirmar'
      };
    }
    async function addSelectedVariantToCart(){
      const id=String(state.product?.id||'');
      if(!/^\d+$/.test(id))throw new Error('No se encontró una variante válida del producto.');
      if(state.cartAddedVariant===id)return;
      const rootPath=window.Shopify?.routes?.root||'/';
      const path=rootPath.replace(/\/?$/, '/')+'cart/add.js';
      const response=await fetch(path,{
        method:'POST',credentials:'same-origin',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({items:[{id:Number(id),quantity:1,properties:cartProperties()}]})
      });
      if(!response.ok){
        const errorData=await response.json().catch(()=>({}));
        throw new Error(errorData.description||errorData.message||`Shopify no pudo añadir la variante (error ${response.status}).`);
      }
      state.cartAddedVariant=id;
    }
    async function checkoutSelectedProduct(){
      // Enlace oficial entregado por CAR MAT 29. Wompi es externo y no
      // crea por sí solo un pedido Shopify ni transmite el total variable.
      // La cotización debe comprobarse con el cliente antes del pago.
      window.location.assign(CONFIG.wompi);
    }
    async function alternatePayment(){
      const note='Hola, estoy intentando pagar esta cotización y quisiera coordinar un pago alternativo vía WhatsApp.\n';
      state.quoteText=note+whatsappText();
      try{
        // Deja el artículo preparado en el carrito, pero NO afirma que exista un pedido pagado.
        await addSelectedVariantToCart();
      }catch(error){
        // WhatsApp sigue disponible; explicamos claramente si no se pudo reservar el artículo.
        alert('No se añadió el producto al carrito: '+(error?.message||'error')+'. Puedes continuar la solicitud por WhatsApp.');
      }
      await shareQuote(true);
    }
    async function renderQuotation(){
      readManual();const panel=$('.ig-quote');if(!panel)return;
      if(!state.product){alert('Selecciona primero tu producto.');showStage('catalog');return;}
      const button=$('[data-generate-quote]');if(button)button.disabled=true;
      showStage('quote');panel.textContent='Preparando tu cotización en una sola imagen…';scrollTo(panel);
      try{
        state.quoteBlob=null;
        const blob=await prepareQuote();
        const frame=document.createElement('div');frame.className='ig507-quote-frame';
        const preview=document.createElement('img');preview.src=state.quoteURL;
        preview.alt='Cotización personalizada completa con vehículo, producto, variante, total y opciones de compra';
        preview.title='Toca la imagen para ampliarla y leer los detalles';
        preview.style.cursor='zoom-in';
        preview.tabIndex=0;
        preview.setAttribute('role','button');
        preview.setAttribute('aria-label','Ampliar cotización para leer los detalles');
        const openQuoteImage=()=>window.open(state.quoteURL,'_blank','noopener');
        preview.addEventListener('click',openQuoteImage);
        preview.addEventListener('keydown',event=>{
          if(event.key==='Enter'||event.key===' '){event.preventDefault();openQuoteImage();}
        });
        frame.append(preview);
        state.quoteText=whatsappText();
        const targets=[
          {name:'Pagar ahora con tarjeta mediante Wompi oficial de CAR MAT 29',x:26,y:1504+QUOTE_LAYOUT.photoExtra,w:508,h:82,run:checkoutSelectedProduct},
          {name:'Pago alternativo vía WhatsApp',x:542,y:1504+QUOTE_LAYOUT.photoExtra,w:512,h:82,run:alternatePayment},
          {name:'Descargar cotización en imagen PNG',x:26,y:1592+QUOTE_LAYOUT.photoExtra,w:332,h:46,run:()=>downloadFile(blob)},
          {name:'Compartir cotización por WhatsApp',x:366,y:1592+QUOTE_LAYOUT.photoExtra,w:334,h:46,run:()=>{state.quoteText=whatsappText();shareQuote(true);}},
          {name:'Recibir cotización por correo electrónico',x:708,y:1592+QUOTE_LAYOUT.photoExtra,w:346,h:46,run:()=>{
            downloadFile(blob);
            const subject=encodeURIComponent('Cotización personalizada CAR MAT 29');
            const body=encodeURIComponent('Te comparto la cotización de CAR MAT 29. Adjunta el PNG descargado a este correo.\n\n'+whatsappText());
            location.href=`mailto:?subject=${subject}&body=${body}`;
          }}
        ];
        targets.forEach(t=>{
          const hit=document.createElement('button');hit.type='button';hit.className='ig507-hit';
          hit.setAttribute('aria-label',t.name);hit.title=t.name;
          hit.style.cssText=`left:${t.x/QUOTE_LAYOUT.width*100}%;top:${t.y/QUOTE_LAYOUT.height*100}%;width:${t.w/QUOTE_LAYOUT.width*100}%;height:${t.h/QUOTE_LAYOUT.height*100}%;`;
          hit.addEventListener('click',t.run);frame.append(hit);
        });
        panel.replaceChildren(frame);
        finishTimer();
        // El cronómetro cubre las cinco etapas y se detiene cuando el PNG está preparado.
        console.info('CAR MAT 29: cotización generada en',state.seconds,'segundos');
      }catch(err){
        showStage('delivery');console.error('IG507 PNG:',err);
        alert('No se pudo crear el PNG: '+(err?.message||'error de imagen')+'. Intenta generar otra vez.');
      }finally{if(button)button.disabled=false;}
    }
    installStyles();header();setupVehicleUploader();setupForm();showStage('welcome');
    readManual();
    console.info(VERSION,'· Campos:',Object.keys(F).length,'· Marcas:',Object.keys(CAR_MODELS).length);
  }
  function boot(){document.querySelectorAll('[data-ig507]').forEach(init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
  document.addEventListener('shopify:section:load',boot);
})();